import { useTiers } from "api/tiers";
import { useMessage } from "hooks/intl";

type Tier = {
  levelId: string;
  name: string;
};

interface Props {
  tierIds?: string[];
}

export const TierDisplay = ({ tierIds }: Props) => {
  const { message } = useMessage();
  const { useTierData } = useTiers();
  const { data: initialTiers } = useTierData(tierIds || []);

  return (
    <div>
      <span>{message({ id: "tier" })}: </span>
      {initialTiers
        ? initialTiers.map((tier: Tier) => (
            <span key={tier.levelId}>{tier.name}</span>
          ))
        : "-"}
    </div>
  );
};
